// extracted by mini-css-extract-plugin
export var container = "index-module--container--GRA9b";
export var description = "index-module--description--FgvrI";
export var h1 = "index-module--h1--XkwxB";
export var more = "index-module--more--1Di80";
export var title = "index-module--title--ZG+Ck";